import axios from 'axios';
import { getServerApi } from '../../config/deployment';

const API_GATEWAY_URL = `${getServerApi()}/api/contracts-gateway`;
const TEMPLATES_ENDPOINT = 'templates';

export default {
    async getTemplates(accountId = '') {
        const response = await axios.get(`${API_GATEWAY_URL}/${TEMPLATES_ENDPOINT}`, {
            params: {
                accountId,
            }
        });

        return response.data.templates;
    },
}


// WEBPACK FOOTER //
// ./src/services/contract-templates/index.js